import { render } from "./Mail.vue?vue&type=template&id=107b3eb3&scoped=true&ts=true"
import script from "./Mail.vue?vue&type=script&lang=ts"
export * from "./Mail.vue?vue&type=script&lang=ts"

import "./Mail.vue?vue&type=style&index=0&id=107b3eb3&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107b3eb3"]])

export default __exports__